import React, { useState, useCallback } from 'react';

import classnames from 'classnames';
import PropTypes from 'prop-types';

import { NumberInput } from 'ui-components/components/number-input';
import { Text, TextType } from 'ui-components/components/text';

import InputValueProps from '../../../../../prop-types/input-value-props';
import { INT_PARAMETER } from '../../../../../constants/parameter-name-for-update';
import messages from './messages';

import style from './style.module.less';

const SetDateFromDaysAfterOrderDate = ({ inputValueProps, onChange, hasError, label }) => {
  const { intParameter } = inputValueProps;
  const [numberOfDays, setNumberOfDays] = useState(intParameter || 0);

  const onChangeDays = useCallback(
    (newValue) => {
      setNumberOfDays(newValue);
    },
    [setNumberOfDays],
  );

  const onBlurDays = useCallback(() => {
    onChange({
      [INT_PARAMETER]: numberOfDays,
    });
  }, [onChange, numberOfDays]);

  const onArrowButtonPress = useCallback(
    (newValue) => {
      setNumberOfDays(newValue);
      onChange({
        [INT_PARAMETER]: newValue,
      });
    },
    [setNumberOfDays, onChange],
  );

  const daysInput = (
    <NumberInput
      className={classnames(style['days-input'], { [style.error]: hasError })}
      onArrowButtonPress={onArrowButtonPress}
      onBlur={onBlurDays}
      onChange={onChangeDays}
      value={numberOfDays}
    />
  );

  return (
    <div className={style['multi-control-row']}>
      <div>{label}</div>
      <Text
        className={style['set-days-around-date']}
        element='div'
        formattedMessageValues={{
          a: () => daysInput,
        }}
        textType={TextType.Paragraph}
        value={messages.setDaysAfterOrderDate}
      />
    </div>
  );
};

SetDateFromDaysAfterOrderDate.propTypes = {
  inputValueProps: InputValueProps.isRequired,
  onChange: PropTypes.func.isRequired,
  hasError: PropTypes.bool.isRequired,
  label: PropTypes.node.isRequired,
};

export default SetDateFromDaysAfterOrderDate;
